import styled, { css } from 'styled-components';
import { FlexBetween, FlexColumn } from '../../../../../styled/common';
import { Breakpoints } from '../../../../../styled/constants';

export const PromotionSectionItem = styled(FlexBetween)<{ $isAuthor: boolean }>`
  position: relative;
  width: 100%;
  padding: ${({ $isAuthor }) => ($isAuthor ? '10px 15px' : '0 10px')};
  height: ${({ $isAuthor }) => ($isAuthor ? 'auto' : '52px')};
  align-items: center;
  gap: ${({ $isAuthor }) => ($isAuthor ? '10px' : '2px')};
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  cursor: pointer;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 15px;

    ${({ $isAuthor }) =>
      !$isAuthor &&
      css`
        height: 64px;
        width: 100%;
        border: 1px solid ${({ theme }) => theme.colors.border.primary};
      `};
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${({ $isAuthor }) =>
      $isAuthor &&
      css`
        background-color: ${({ theme }) => theme.colors.background.primary};
        border: 1px solid ${({ theme }) => theme.colors.border.primary};
        padding: 10px 15px;
      `};

    ${({ $isAuthor }) =>
      !$isAuthor &&
      css`
        height: 52px;
        min-width: 100px;
        padding: 10px;
      `};
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    ${({ $isAuthor }) =>
      !$isAuthor &&
      css`
        width: 100px;
      `}
  }
`;

export const PromotionItemContent = styled(FlexColumn)`
  justify-content: space-between;
`;
